import { questionOpenStateId } from '../constants/common';

export const needAnswer = (question) =>
  question?.stateId === questionOpenStateId && question?.notAnswered;
